import { getUserCapabilities, isIdUser } from "../../services/UserService";
import { Capability } from "../../types/Capability";
import { selectPersistTimestamp, selectUserId } from "../selectors/userSelectors";
import {
    setHasFleetAccess,
    setIsTechManager,
    setPersistTimestamp,
    setUserCapabilities,
    setUserId
} from "../slices/userSlice";
import { AppThunk, persistor } from "../store";
import { AmplifyUser } from "@aws-amplify/ui";
import { fetchOrder, fetchOrderByList } from "./fetchOrder";
import { PERSIST_TIMEOUT } from "../../utils/Constants";
import { fetchNotifications } from "./notificationsThunks";

export const initFetchData =
    (user: AmplifyUser): AppThunk =>
    async (dispatch, getState) => {
        const persistTimestamp = selectPersistTimestamp(getState());

        const currentTimestamp = new Date().getTime();

        if (persistTimestamp) {
            if (currentTimestamp - persistTimestamp > PERSIST_TIMEOUT) {
                await persistor.purge();
            }
        }

        const state = getState();
        const userId = selectUserId(state);
        
        if (user && !userId) {
            persistor.pause();
            const currentTimestamp = new Date().getTime();

            dispatch(setUserId(user.username));

            const userCapabilities = await getUserCapabilities(user.username);

            dispatch(setUserCapabilities(userCapabilities));
            dispatch(setHasFleetAccess(isIdUser(userCapabilities)));

            const isTechManager = userCapabilities.includes(
                Capability.CAP_FLEETAPP_VIEW_RECTIFICATIONS
            );
            
            dispatch(setIsTechManager(isTechManager));
            await dispatch(fetchDataByPath(isTechManager, false));

            persistor.persist();

            dispatch(fetchNotifications());
            dispatch(setPersistTimestamp(currentTimestamp));
        }
    };

export const fetchDataByPath =
    (
        techManager: boolean,
        byList: boolean
    ): AppThunk<Promise<boolean>> =>
    async (dispatch) => {
        let path = window.location.pathname.split("/")[1] ?? "";

        if (techManager) {
            path = "techManager";
        }

        let fetchOrderByPath = fetchOrder[path];

        if (byList) {
            fetchOrderByPath = fetchOrderByList[path];
        }

        if (fetchOrderByPath && Array.isArray(fetchOrderByPath)) {
            for (const appThunks of fetchOrderByPath) {
                const promises = appThunks.map((appThunk) => dispatch(appThunk));
                await Promise.all(promises);
            }
        } else {
            console.warn(`No fetch order found for path: "${path}", byList: ${byList}, fetchOrderByPath:`, fetchOrderByPath);
        }

        return true;
    };
